<link href="https://maxcdn.bootstrapcdn.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet" />
<ng-scrollbar visibility="hover" track="all" pointerEventsMethod="scrollbar">
    <div class="row vh-100">
        <div class="container-fluid">
            <div class="col-md-12 well-done-container">
                <div class=" col-md-12 bg-white mb-4" style="padding: 20px 0 5px 0">


                    <div class="col-md-2">
                        <img style="width: 150px;margin-top: -5px;"
                            src="https://www.financeplus.me/wp-content/uploads/2020/07/Finance-Plus-LOGO-COLOR-e1592294302289.png"
                            alt="">
                    </div>
                    <div class="col-md-6 no-padding">
                        <div class="col-md-4">
                            <h2 style="margin-top: 5px;">
                                <a href="javascript" routerLink="/timeline" routerLinkActive="active">
                                    <span
                                        style="text-transform: uppercase;color: #43425d;padding-top: 10px;">Filtriranje
                                        zadataka</span></a>
                            </h2>
                        </div>
                        <div class="col-md-8 no-padding">
                            <nav aria-label="breadcrumb bg-white text-right">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a routerLink="/home">Početna</a></li>
                                    <li class="breadcrumb-item"><a href="javascript:">Filtriranje zadataka</a></li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                    <div class="col-md-4 text-right">
                        <button routerLink="/home" routerLinkActive="active"
                            class="btn btn-outline-primary btn-sm mr-2">
                            Moj radni sto
                        </button>
                        <button (click)="getXls()" class="btn btn-outline-info btn-sm mr-2"
                            [disabled]="executingExcelExport.disabled">
                            <i class="fa fa-file-excel"></i> {{ executingExcelExport.label }}
                        </button>
                    </div>
                </div>
            </div>


            <div class="col-md-12 margin-bottom-20">
                <button type="button" class="btn btn-info" style="margin-left: 6px;float: right"
                    (click)="resetFilter()">
                    Resetuj
                </button>
                <button type="button" style="float: right" class="btn btn-warning" (click)="drawTable()">Filtriraj
                </button>
                <div *ngIf="admin===true" class="form-check float-right m-2">
                    <input (click)="previewAllTasks($event)" [checked]="showAll" [(ngModel)]="showAll"
                        class="form-check-input" type="checkbox" value="" id="flexCheckDefault">
                    <label class="form-check-label" for="flexCheckDefault">
                        Prikaži sve
                    </label>
                </div>
            </div>


            <div class="spinner-border spinner-margins" role="status" *ngIf="showLoader">
                <span class="sr-only">Loading...</span>
            </div>

            <div class="col-md-12" *ngIf="!showLoader">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th style="width: 13%" scope="col">Naslov</th>
                            <th style="width: 13%" scope="col">Opis</th>
                            <th style="width: 6%" scope="col">Broj zadatka</th>
                            <th style="width: 6%" scope="col">Tip</th>
                            <th style="width: 10%" scope="col">Odgovorni</th>
                            <th style="width: 10%" scope="col">Validator</th>
                            <th style="width: 10%" scope="col">Kreator</th>
                            <th style="width: 9%" scope="col">Projekat</th>
                            <th style="width: 8%" scope="col">Datum početka</th>
                            <th style="width: 8%" scope="col">Datum završetka</th>

                            <th style="width: 10%" scope="col">
                                <div class="input-group">
                                    <span style="margin-top: 10px;"> Rok </span>
                                    <button style="margin-top: 10px;    width: 10px;height: 10px;"
                                        *ngIf="deadlineAsc===true" type="button" class="btn btn-light pt-0"
                                        (click)="sortDeadline()">
                                        <i title="Sortiraj po opadajućem redosledu" class="fa fa-sort-up"></i>
                                    </button>
                                    <button style="margin-top: 6px;   width: 10px;height: 10px"
                                        *ngIf="deadlineAsc===false" type="button" class="btn btn-light pt-0"
                                        (click)="sortDeadline()">
                                        <i title="Sortiraj u rastućem redosledu" class="fa fa-sort-down"></i>
                                    </button>
                                </div>


                            </th>
                            <th style="width: 8%" scope="col">Datum kreiranja</th>

                            <th scope="col">Status</th>
                        </tr>
                        <tr>

                            <td></td>

                            <td>
                                <div style="margin-left: -14px" class="full-width"><input class="form-control"
                                        [(ngModel)]="datasForTable.Naslov">
                                </div>
                            </td>

                            <td>
                                <div style="margin-left: -21px" class="full-width no-padding"><input
                                        class="form-control" [(ngModel)]="datasForTable.Opis">
                                </div>
                            </td>
                            <td>
                                <div style="margin-left: -21px;" class="col-md-12 no-padding float-right"><input
                                        class="form-control" [(ngModel)]="datasForTable.Identifikator">
                                </div>
                            </td>
                            <td>
                                <div style="margin-left: -22px" class="col-md-12">
                                    <div class="col-md-12 no-padding">
                                        <mat-select id="select1" class="form-control select"
                                            [(ngModel)]="datasForTable.Tip">
                                            <mat-option value="task">Zadatak</mat-option>
                                            <mat-option value="meeting">Sastanak</mat-option>
                                        </mat-select>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <div style="margin-left: -24px" class="col-md-12"><input class="form-control"
                                        [(ngModel)]="assigned">
                                </div>
                            </td>
                            <td>
                                <div style="margin-left: -20px" class="col-md-12"><input class="form-control"
                                        [(ngModel)]="validator">
                                </div>
                            </td>
                            <td>
                                <div style="margin-left: -20px" class="col-md-12"><input class="form-control"
                                        [(ngModel)]="creator">
                                </div>
                            </td>
                            <td>
                                <div style="padding: 0" class="col-md-12">
                                    <input class="form-control" [(ngModel)]="datasForTable.Projekat">
                                </div>
                            </td>
                            <td>
                                <div style="padding: 0" class="col-md-12 text-center">
                                    <input #executionRangeInput class="form-control d-inline-block"
                                        placeholder="Izaberite datum" name="dp" readonly
                                        style="background: white;width: 80%" [(ngModel)]="modelExecution" ngbDatepicker
                                        [dayTemplate]="e" [autoClose]="false" [displayMonths]="2" [maxDate]="maxDate"
                                        [minDate]="minDate"
                                        (click)="execution_date_range.toggle();deadline_date_range.close();end_date_date_range.close()"
                                        #execution_date_range="ngbDatepicker">
                                    <span (click)="resetDateFilter('execution');modelExecution=''"
                                        class="input-group-addon ml-1 cursor grey-color">
                                        <i class="fa fa-times"></i>
                                    </span>
                                    <ng-template #e let-date_e="date" let-focused="focused_e">
                                        <span class="custom-day"
                                            [class.range]="isFromExecution(date_e) || isToExecution(date_e) || isInsideExecution(date_e) || isHoveredExecution(date_e)"
                                            [class.faded]="isHoveredExecution(date_e) || isInsideExecution(date_e)"
                                            (click)="onDateSelection(date_e,'execution');"
                                            (mouseenter)="hoveredDateExecution = date_e"
                                            (mouseleave)="hoveredDateExecution = null">
                                            {{ date_e.day }}
                                        </span>
                                    </ng-template>
                                </div>
                            </td>
                            <td>
                                <div style="padding: 0" class="col-md-12 text-center">
                                    <input #endDateRangeInput class="form-control d-inline-block"
                                        placeholder="Izaberite datum" name="dp" [(ngModel)]="modelEndDate" ngbDatepicker
                                        readonly style="background: white;width: 80%" [dayTemplate]="end"
                                        [autoClose]="false" [displayMonths]="2" [maxDate]="maxDate" [minDate]="minDate"
                                        (click)="deadline_date_range.close();execution_date_range.close();end_date_date_range.toggle()"
                                        #end_date_date_range="ngbDatepicker">
                                    <span (click)="resetDateFilter('endDate');modelEndDate=''"
                                        class="input-group-addon ml-1 cursor grey-color">
                                        <i class="fa fa-times"></i>
                                    </span>
                                    <ng-template #end let-date_end="date" let-focused="focused">
                                        <span class="custom-day"
                                            [class.range]="isFromEndDate(date_end) || isToEndDate(date_end) || isInsideEndDate(date_end) || isHoveredEndDate(date_end)"
                                            [class.faded]="isHoveredEndDate(date_end) || isInsideEndDate(date_end)"
                                            (click)="onDateSelection(date_end,'endDate');"
                                            (mouseenter)="hoveredDateEndDate = date_end"
                                            (mouseleave)="hoveredDateEndDate = null">
                                            {{ date_end.day }}
                                        </span>
                                    </ng-template>


                                </div>
                            </td>
                            <td>
                                <div style="padding: 0" class="col-md-12 text-center">

                                    <input #deadlineRangeInput class="form-control d-inline-block"
                                        placeholder="Izaberite datum" name="dp" readonly
                                        style="background: white;width: 80%" [(ngModel)]="model" ngbDatepicker
                                        [dayTemplate]="t" [autoClose]="false" [displayMonths]="2" [maxDate]="maxDate"
                                        [minDate]="minDate"
                                        (click)="deadline_date_range.toggle();execution_date_range.close();end_date_date_range.close()"
                                        #deadline_date_range="ngbDatepicker">
                                    <span (click)="resetDateFilter('deadline');model=''"
                                        class="input-group-addon ml-1 cursor grey-color">
                                        <i class="fa fa-times"></i>
                                    </span>
                                    <ng-template #t let-date="date" let-focused="focused">
                                        <span class="custom-day"
                                            [class.range]="isFromDeadline(date) || isToDeadline(date) || isInsideDeadline(date) || isHoveredDeadline(date)"
                                            [class.faded]="isHoveredDeadline(date) || isInsideDeadline(date)"
                                            (click)="onDateSelection(date,'deadline');"
                                            (mouseenter)="hoveredDateDeadline = date"
                                            (mouseleave)="hoveredDateDeadline = null">
                                            {{ date.day }}
                                        </span>
                                    </ng-template>


                                </div>
                            </td>
                            <td>
                                <div style="padding: 0" class="col-md-12 text-center">
                                    <input #creationDateRangeInput class="form-control d-inline-block"
                                        placeholder="Izaberite datum" name="dp" [(ngModel)]="modelCreationDate" ngbDatepicker
                                        readonly style="background: white;width: 80%" [dayTemplate]="creation"
                                        [autoClose]="false" [displayMonths]="2" [maxDate]="maxDate" [minDate]="minDate"
                                        (click)="deadline_date_range.close();execution_date_range.close();creation_date_range.toggle()"
                                        #creation_date_range="ngbDatepicker">
                                    <span (click)="resetDateFilter('creationDate');modelCreationDate=''"
                                        class="input-group-addon ml-1 cursor grey-color">
                                        <i class="fa fa-times"></i>
                                    </span>
                                    <ng-template #creation let-date_creation="date" let-focused="focused">
                                        <span class="custom-day"
                                            [class.range]="isFromCreationDate(date_creation) || isToCreationDate(date_creation) || isInsideCreationDate(date_creation) || isHoveredCreationDate(date_creation)"
                                            [class.faded]="isHoveredCreationDate(date_creation) || isInsideCreationDate(date_creation)"
                                            (click)="onDateSelection(date_creation,'creationDate');"
                                            (mouseenter)="hoveredDateCreationDate = date_creation"
                                            (mouseleave)="hoveredDateCreationDate = null">
                                            {{ date_creation.day }}
                                        </span>
                                    </ng-template>
                                </div>
                            </td>
                            <td>
                                <div style="padding: 0" class="col-md-12">
                                    <div class="col-md-12 no-padding">

                                        <mat-select #selector class="select" id="select" class="form-control">
                                            <mat-option *ngFor="let status of statuses;index as i"
                                                (click)="selector.open();">
                                                <mat-checkbox (change)="checkStatus(i)"
                                                    [checked]="status.selected">{{status.name}}</mat-checkbox>

                                            </mat-option>

                                        </mat-select>


                                    </div>


                                </div>
                            </td>
                        </tr>
                    </thead>
                    <tbody>

                        <tr class="context-menu" *ngFor="let task of tasks; index as i "
                            [routerLink]="['/view-task',task._id]" class="cursor">

                            <td scope="row">
                                {{ serialNumber + i }}
                            </td>


                            <td [title]="task.title">


                                <a style="color: black" [routerLink]="['/view-task',task._id]">
                                    <div *ngIf="task.validation_returns >0" style="  height: 5px; width: 5px; background-color: #bb0005; border-radius: 50%; display: inline-block;margin-right: 2px;vertical-align: middle"></div>
                                    {{ task.title | shortenText:0:5 }}
                                </a>
                            </td>
                            <td [title]="task.description">{{ task.description | shortenText:0:7 }}</td>
                            <td class="text-center">{{ task.identifier }}</td>
                            <td>{{ task.type }}</td>

                            <td>
                                <div *ngFor="let assigned of task.assignedData; index as j">
                                    <span class="badge badge-secondary">{{ assigned.first_name }} {{
                                        assigned.last_name }}&nbsp;
                                    </span>

                                </div>
                            </td>
                            <td>
                                <div *ngFor="let validator of task.validatorsData; index as z">
                                    <span class="badge badge-secondary">{{ validator.first_name }} {{
                                        validator.last_name }}&nbsp;
                                    </span>
                                    <br>
                                </div>
                            </td>
                            <td>
                                <span class="badge badge-secondary">
                                    {{task.creatorData.first_name + ' ' +
                                    task.creatorData.last_name }}
                                </span>
                            </td>
                            <td style="text-align: center">{{task.project !== undefined && task.project !== null ?
                                task.project['name'] : '/' }}</td>
                            <td style="text-align: center">{{ task.execution !== null ? (task.execution | date:'dd.MM.Y
                                HH:mm') : '/' }}</td>
                            <td style="text-align: center">{{ task.end_time !== null ? (task.end_time| date:'dd.MM.Y
                                HH:mm') : '/' }}</td>
                            <td style="text-align: center">{{ task.deadline | date:'dd.MM.Y HH:mm' }}</td>
                            <td style="text-align: center">{{ task.created_at | date:'dd.MM.Y HH:mm' }}</td>


                            <td style="text-align: center" *ngIf="task.status === 'todo'"><span
                                    class="badge badge-info">Otvoren</span></td>
                            <td style="text-align: center" *ngIf="task.status === 'ddone'"><span
                                    class="badge badge-success">Završen</span>
                            </td>
                            <td style="text-align: center" *ngIf="task.status === 'inprogress'"><span
                                    class="badge badge-light">U radu</span></td>
                            <td style="text-align: center" *ngIf="task.status === 'postponed'"><span
                                    class="badge badge-secondary">Odložen</span></td>
                            <td style="text-align: center" *ngIf="task.status === 'canceled'"><span
                                    class="badge badge-danger">Otkazan</span></td>
                            <td style="text-align: center" *ngIf="task.status === 'validated'"><span
                                    class="badge badge-dark">Odobren</span>
                            </td>
                            <td style="text-align: center" *ngIf="task.status =='deleted'"><span
                                    class="badge badge-danger">Izbrisan</span></td>


                        </tr>
                    </tbody>
                </table>
                <div class="d-flex justify-content-between p-2">
                    <ngb-pagination (pageChange)="onPageChange($event)" [pageSize]="pageSize"
                        [collectionSize]="collectionSize" [(page)]="page" [maxSize]="5" [rotate]="true"
                        [boundaryLinks]="true"></ngb-pagination>
                </div>
            </div>

        </div>
    </div>
</ng-scrollbar>